import { map, OperatorFunction } from 'rxjs';

// Unwraps the `data` envelope every hub response carries, e.g.
// `this.agentsService.agencySession().pipe(unwrap())`. Pagination `metadata` is dropped, so read the full
// response instead where the screen pages.
export function unwrap<T>(): OperatorFunction<{ data: T }, T> {
  return map(response => response.data);
}
